import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { CoreParkLogo } from '@components/corepark-logo'

@Component({
    templateUrl: './auth-layout.component.html',
    styleUrls: ['./auth-layout.component.scss'],
    imports: [RouterOutlet, CoreParkLogo]
})
export class AuthLayoutLayout {}
